module.exports = __webpack_public_path__ + "static/media/homer-punch.19ae86ec.png";